export const subscribeEmailToKlaviyo = async (email: string): Promise<void> => {
  const listId = process.env.REACT_APP_KLAVIYO_LIST_ID;

  if (!listId) {
    throw new Error('Klaviyo config missing. Set REACT_APP_KLAVIYO_LIST_ID.');
  }

  const body = new URLSearchParams({
    g: listId,
    email,
    '$fields': '$source,$consent',
    '$list_fields': '$consent',
    '$source': 'Mining Super-Cycle Landing Page',
    '$consent': 'email'
  });

  const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: body.toString()
  });

  if (!response.ok) {
    throw new Error(`Klaviyo request failed with status ${response.status}`);
  }

  const data = await response.json().catch(() => ({}));
  if (data && data.success === false) {
    throw new Error(data.errors?.[0] || data.message || 'Klaviyo rejected the subscription.');
  }
};
